<template>

  <transition name="fade">
    <div v-if="isEditElementLoading" class="common-shadow-loader">
      <Loader/>
    </div>
  </transition>

  <div class="edit-element" v-if="elementData">
    <label for="value" class="form-label">Количество, {{ elementData.unit }}</label>
    <input v-model="elementForm.value" type="number" id="value" class="form-control"
           :class="{'is_invalid': errors.value}" placeholder="Введите количество" min="1">
    <span v-for="(error, id) in errors.value" :key="id" class="error-message">{{ error }}</span>
    <div class="edit-element-buttons">
      <button :disabled="isDisabledSubmitButton" @click="submitForm" class="btn btn-primary">Изменить</button>
      <button class="btn btn-primary" @click="closeModal">Закрыть</button>
    </div>

  </div>

</template>

<script>
import UseEditElement from "@/composables/crudElements/UseEditElement"
import Loader from "@/components/common/Loader";

export default {
  name: "EditElement",
  components: {Loader},
  props: {
    modelValue: {
      type: Boolean
    },
  },
  setup() {
    return {
      ...UseEditElement()
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:modelValue', false)
    },
    submitForm() {
      this.editElement(this.elementForm)
        .then(this.closeModal)
    }
  },
  data() {
    return {
      elementForm: {
        value: undefined
      },
      oldValue: undefined
    }
  },
  computed: {
    isDisabledSubmitButton() {
      return !this.elementForm.value
        || this.isEditElementLoading
        || this.oldValue === this.elementForm.value
        || this.errors.value
    }
  },
  watch: {
    elementData: {
      handler(newVal) {
        if (newVal) {
          this.elementForm.value = this.oldValue = newVal.value
        }
      },
      deep: true
    },
    'elementForm.value': {
      handler() {
        this.clearValueError()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-element {

  .edit-element-buttons {
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    button {
      margin-top: 5px;
      width: 100%;
    }

  }

  input.is_invalid {
    border: 1px solid var(--common-red);
  }

  .error-message {
    color: var(--common-red);
  }

}
</style>
